<span class="badge badge-pill" [ngStyle]="{ 'background-color': getColor()}">
  @if (index) {
    <span>{{index}} - </span>
    }{{avverkningsgrupp | avverkningsgruppForkortning}}
  </span>
